import { render, staticRenderFns } from "./mainland.vue?vue&type=template&id=1fd472f4&scoped=true&"
import script from "./mainland.vue?vue&type=script&lang=js&"
export * from "./mainland.vue?vue&type=script&lang=js&"
import style0 from "./mainland.vue?vue&type=style&index=0&id=1fd472f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd472f4",
  null
  
)

export default component.exports